import { render, staticRenderFns } from "./conceito-escala-editor.vue?vue&type=template&id=5dd79e42"
import script from "./conceito-escala-editor.vue?vue&type=script&lang=js"
export * from "./conceito-escala-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports